module.exports = __webpack_public_path__ + "img/biometano.fe194346.svg";